import React, { Component } from "react";
import { connect } from "react-redux";
import {
  LANGUAGE,
  AUTH_SERVER_URL,
  AUTHORIZATION_ENDPOINT,
  CODE_AUTH_URL,
  GENERALI_CODE_AUTH_URL,
  OLD_LOGIN_URL,
} from "../utils/Constants";
import { POST } from "../services/RequestServices";
import { getParameterByName } from "../utils/CommonUtils";
import { getItem, setItem } from "../utils/storage";
import Logo from "../assets/images/logo.svg";
import "../styles/login.css";
import { isGenerali } from "../utils/domain";
import LanguageSelector from "./LanguageSelector";
import { bindActionCreators } from "redux";
import { setLanguage } from "../actions/CommonActions";
import ParticleEffect from "./ParticleEffect";

const isIE = false || !!document.documentMode;

console.log("cache busting");

class Auth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      websiteUrl: window.location.href,
      showSuccessMsg: false,
      showFailedMsg: false,
      username: "",
      authAgentWephone: false,
      oldAuthUrl: "",
    };

    this.redirectToAuth = this.redirectToAuth.bind(this);
    this.onInputKeyDown = this.onInputKeyDown.bind(this);
    this.validateName = this.validateName.bind(this);
    this.getInvoxAPIAuthCode = this.getInvoxAPIAuthCode.bind(this);
    this.redirectToApp = this.redirectToApp.bind(this);
    this.loginError = this.loginError.bind(this);
    this.btnloginReset = this.btnloginReset.bind(this);
    this.handleLoginRedirect = this.handleLoginRedirect.bind(this);
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectUri = urlParams.get("redirect");
    const iss_cookie = this.checkCookie("autologinredirectdash");
    if (iss_cookie) {
      const requestParams = new URLSearchParams({
        scope: "openid",
        response_type: "code",
        client_id: this.getAuthClient(redirectUri),
        redirect_uri: redirectUri,
      });

      window.location.href = iss_cookie + AUTHORIZATION_ENDPOINT + "?" + requestParams.toString();
    }

    if (urlParams.has("realm")) {
      const realm = urlParams.get("realm");
      const requestParams = new URLSearchParams({
        scope: "openid",
        response_type: "code",
        client_id: this.getAuthClient(redirectUri),
        redirect_uri: redirectUri,
      });

      window.location.href =
        AUTH_SERVER_URL + "/realms/" + realm + AUTHORIZATION_ENDPOINT + "?" + requestParams.toString();
    }
    // *********** REDIRECT LINK ***********
    const origin = window.location.origin;
    const redirectTarget = `${origin}/login/`;
    let oldAuthUrl = redirectTarget;

    if (redirectUri) {
      try {
        const redirectUrl = new URL(redirectUri);
        const normalizedPath = redirectUrl.pathname.replace(/\/+$/, "");
        console.log(normalizedPath);
        // const validRedirects = ["/50/webagent", "/30/webphone", "/30/webphonego"];
        const allowedDomains = ["go.invoxcontact.io", "test.invoxcontact.io", "staging.invoxcontact.io", "localhost"];
        const isInvoxDomain = allowedDomains.includes(redirectUrl.hostname);

        // const isValidRedirect = isInvoxDomain && validRedirects.includes(normalizedPath);
        const isValidRedirect = isInvoxDomain;
        if (isValidRedirect) {
          // let version = "";
          // if (normalizedPath.includes("/webphone")) {
          //   version = "30";
          // } else if (normalizedPath.includes("/webagent")) {
          //   version = "50";
          // }

          let newRedirectUri = redirectUri; // fallback

          // // Inject version if we have one and it’s not already present
          // if (version && !/^\/(30|50)\//.test(redirectUrl.pathname)) {
          //   newRedirectUri = `${redirectUrl.origin}/${version}${redirectUrl.pathname}${redirectUrl.search}${redirectUrl.hash}`;
          // }

          const currentUrl = new URL(window.location);

          if (currentUrl.hostname === "localhost") {
            oldAuthUrl = `${currentUrl.protocol}//${currentUrl.hostname}:${currentUrl.port}/login/?redirect=${newRedirectUri}`;
          } else {
            oldAuthUrl = `${window.location.protocol}//${currentUrl.hostname}/login/?redirect=${newRedirectUri}`;
          }
        }
      } catch (err) {
        console.error("Invalid redirect URI:", redirectUri, err);
      }
    }
    console.log(oldAuthUrl);
    this.setState({
      oldAuthUrl,
      authAgentWephone: true,
    });

    // *********** END OF REDIRECT LINK ***********

    /*if (window.location.href.includes('preview=dashboard')) {
            console.log('Entra aqui en el redirect');
            this.redirectToAuth();
        }
        /*if (window.location.href.includes('?redirect=')) {
        
            const [_, redirectURL] = window.location.href.split('?redirect=').map((strUrl) => new URL(strUrl));
            const redirectParams = redirectURL.searchParams;

            const language = getItem(LANGUAGE) || "es";
            if(language !== null) {
                this.props.setLanguage(language);
            }

            if (redirectParams.has('iss') && redirectParams.has('code')) {

                this.loginButton.style.display = "none";
                this.loggingButton.style.display = "block";

                this.getInvoxAPIAuthCode(redirectParams.get('iss'), redirectParams.get('code'), redirectURL.origin + redirectURL.pathname)
                    .then(response => response.json())
                    .then(response => {
                        this.redirectToApp(response);
                    })
                    .catch(error => {
                        window.location.href = redirectURL.origin + redirectURL.pathname;
                    })

            }

        }*/
  }

  checkCookie(name) {
    const match = document.cookie.split("; ").find((cookie) => cookie.startsWith(`${name}=`));
    return match ? decodeURIComponent(match.split("=")[1]) : null;
  }

  validateName() {
    let valid = this.nameInput.value;
    if (valid && this.nameInput.classList.contains("error_form")) {
      this.nameInput.classList.remove("error_form");
      this.errorMsgRealmName.style.display = "none";
    } else if (!valid && !this.nameInput.classList.contains("error_form")) {
      this.nameInput.classList.add("error_form");
      this.errorMsgRealmName.style.display = "block";
    }
    return valid;
  }

  onInputKeyDown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.redirectToAuth();
    }
  }

  getAuthClient(redirectUri) {
    const url = new URL(redirectUri);
    if (url.pathname.startsWith("/autodialer") || url.pathname.startsWith("/permissions")) {
      return "numintec-go-admin";
    } else if (url.pathname.startsWith("/analytics")) {
      return "numintec-go-dashboard";
    } else if (url.pathname.startsWith("/landing") || url.pathname.startsWith("/profile")) {
      return "numintec-common";
    } else {
      return "numintec-go";
    }
  }

  redirectToAuth() {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectUri = urlParams.get("redirect");

    if (this.state.showFailedMsg) this.setState({ showFailedMsg: false });

    let isNameValid = this.validateName();

    if (!!isNameValid) {
      this.loginButton.style.display = "none";
      this.loggingButton.style.display = "block";

      const requestParams = new URLSearchParams({
        scope: "openid",
        response_type: "code",
        client_id: this.getAuthClient(redirectUri),
        redirect_uri: redirectUri,
      });

      window.location.href =
        AUTH_SERVER_URL + "/realms/" + this.nameInput.value + AUTHORIZATION_ENDPOINT + "?" + requestParams.toString();
    }
  }

  getInvoxAPIAuthCode(iss, code, redirectUri) {
    const headers = {
      "Content-Type": "application/json",
    };
    const params = {
      code: code,
      iss: iss,
      client_id: this.getAuthClient(redirectUri),
      redirect_uri: redirectUri,
    };
    const url = isGenerali() ? GENERALI_CODE_AUTH_URL : CODE_AUTH_URL;
    return POST(url, headers, params);
  }

  redirectToApp(result) {
    this.btnloginReset();
    this.handleLoginRedirect(result.code);
  }

  loginError(error) {
    this.setState({ showFailedMsg: true });
    this.btnloginReset();
  }

  handleLoginRedirect(token) {
    const websiteUrl = window.location.href;
    const numintecTest = "//test.invoxcontact.io";
    const numintecStaging = "//staging.invoxcontact.io";
    const numintecProd = "//go.invoxcontact.io";
    const generaliTest = "//gtest.invoxcontact.io";
    const generaliStaging = "//gstaging.invoxcontact.io";
    const generaliProd = "//ggo.invoxcontact.io";
    const generaliOldProd = "//go-generali.invoxcontact.io";

    let redirectURL = getParameterByName("redirect");

    if (redirectURL === null || redirectURL === "") {
      if (websiteUrl.includes(numintecTest)) {
        redirectURL = "http://test.invoxcontact.io/profile/";
      } else if (websiteUrl.includes(numintecStaging)) {
        redirectURL = "http://staging.invoxcontact.io/profile/";
      } else if (websiteUrl.includes(numintecProd)) {
        redirectURL = "http://go.invoxcontact.io/profile/";
      } else if (websiteUrl.includes(generaliTest)) {
        redirectURL = "http://gtest.invoxcontact.io/profile/";
      } else if (websiteUrl.includes(generaliStaging)) {
        redirectURL = "http://gstaging.invoxcontact.io/profile/";
      } else if (websiteUrl.includes(generaliProd)) {
        redirectURL = "http://ggo.invoxcontact.io/profile/";
      } else if (websiteUrl.includes(generaliOldProd)) {
        redirectURL = "http://go-generali.invoxcontact.io/autodialer/";
      } else if (
        websiteUrl.includes("localhost") ||
        websiteUrl.includes("https://numintec-login-remastered.netlify.app/")
      ) {
        redirectURL = "http://test.invoxcontact.io/profile/";
      }
    }

    window.location = redirectURL + "?tk=" + token;
  }

  btnloginReset(disableLogin = false) {
    this.loginButton.style.display = "block";
    this.loginButton.disabled = disableLogin;
    this.loggingButton.style.display = "none";
  }

  render() {
    let { translations, selectedLanguage } = this.props;
    return (
      <section className={isIE ? "login-page ie_bg" : "login-page login-bg"}>
        <div className="login-page-data">
          <div className="main-logo-div text-center">
            <img src={Logo} alt="Logo" />
          </div>
          <div className="content-center container">
            <div className="row">
              <div className="col-lg-6 col-md-12">
                <div className="card-plain">
                  <div className="heading">
                    <h2>{translations.login[selectedLanguage]}</h2>
                  </div>
                  <form className="form login_form">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control text-box"
                        placeholder={translations.realmName[selectedLanguage]}
                        ref={(nameInput) => (this.nameInput = nameInput)}
                        onInput={this.validateName}
                        onKeyDown={this.onInputKeyDown}
                        autoFocus
                      />
                      <div className="error_msg_login">
                        <p
                          ref={(errorMsgRealmName) => (this.errorMsgRealmName = errorMsgRealmName)}
                          className="error_msg error_msg_un"
                        >
                          {translations.realmNameWarning[selectedLanguage]}
                        </p>
                      </div>
                    </div>
                  </form>

                  <div className="card-plain-footer">
                    <button
                      type="button"
                      className="login-button"
                      ref={(loginButton) => (this.loginButton = loginButton)}
                      onClick={this.redirectToAuth}
                    >
                      {translations.continue[selectedLanguage]}
                    </button>
                    <button
                      type="button"
                      ref={(loggingButton) => (this.loggingButton = loggingButton)}
                      className="logging_button"
                    >
                      <i className="fa fa-spinner fa-spin hidden"></i>
                      {translations.login[selectedLanguage]}
                    </button>
                  </div>

                  {/* Enlace para usuarios sin MFA */}
                  {this.state.authAgentWephone && (
                    <div className="no-mfa-link text-center" style={{ marginTop: "15px" }}>
                      <p style={{ fontSize: "14px" }}>
                        {translations.noMfaMsg[selectedLanguage]}
                        <br />
                        <a
                          href={this.state.oldAuthUrl}
                          target="_self"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "underline" }}
                        >
                          {translations.noMfaLinkText[selectedLanguage]}
                        </a>
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {!isIE && <ParticleEffect />}
        </div>
        <LanguageSelector />
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    translations: state.common.translations,
    selectedLanguage: state.common.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setLanguage,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
